export function _isInView(t, n, e, s) {
  if (null == t) return !1;
  n = n || !1, e = e || !1;
  var i = t.getBoundingClientRect();
  return null != i && (i.top >= 0 && i.top <= (window.innerHeight || document.documentElement.clientHeight) || !n) && (i.left >= 0 || !s) && (i.bottom >= 0 && i.bottom <= (window.innerHeight || document.documentElement.clientHeight) || !e) && (i.right <= (window.innerWidth || document.documentElement.clientWidth) || !s);
}
export var DOMUtils = {
  wu: null,
  eo: _isInView
};
export var DIRECTIONS = {
  Te: "up",
  $e: "down",
  ot: "left",
  et: "right"
};
export function supportsPassive() {
  if (null == DOMUtils.wu) {
    DOMUtils.wu = !1;

    try {
      var t = Object.defineProperty({}, "passive", {
        get: function get() {
          DOMUtils.wu = !0;
        }
      });
      window.addEventListener("testPassive", null, t), window.removeEventListener("testPassive", null, t);
    } catch (t) {}
  }

  return DOMUtils.wu;
}
export function addPassiveEventListener(t, n, e) {
  t.addEventListener(n, e, !!supportsPassive() && {
    passive: !0
  });
}
export function topIsInView(t) {
  return DOMUtils.eo(t, !0, !1, !1);
}
export function bottomIsInView(t) {
  return DOMUtils.eo(t, !1, !0, !1);
}
export function clickElement(t) {
  if (t.onclick) {
    var n = document.createEvent("MouseEvents");
    n.initEvent("click", !0, !0), t.onclick.apply(t, [n]);
  }
}
export function detectSwipe(t, n, e) {
  var s = null,
      i = null;
  addPassiveEventListener(t, "touchstart", function (t) {
    s = t.touches[0].clientX, i = t.touches[0].clientY;
  }), addPassiveEventListener(t, "touchmove", function (o) {
    if (null == s || null == i) return;
    var l = s - o.touches[0].clientX,
        u = i - o.touches[0].clientY;
    Math.abs(l) > Math.abs(u) && Math.abs(l) >= 25 ? ((l > 0 && n === DIRECTIONS.ot || l < 0 && n === DIRECTIONS.et) && e(o), s = null, i = null) : Math.abs(u) >= 25 && ((u > 0 && n === DIRECTIONS.Te && t.scrollTop === t.scrollHeight - t.offsetHeight || u < 0 && n === DIRECTIONS.$e && 0 === t.scrollTop) && e(o), s = null, i = null);
  });
}
export function buildSvg(t, n, e) {
  var s = "http://www.w3.org/2000/svg",
      i = document.createElementNS(s, "svg");
  i.setAttribute("viewBox", t), i.setAttribute("xmlns", s);
  var o = document.createElementNS(s, "path");
  return o.setAttribute("d", n), null != e && o.setAttribute("fill", e), i.appendChild(o), i;
}